import React from "react";
import { Organisation, User } from "../../../types";
import UsersTable from "./users-table";

interface UsersTableViewProps {
  filteredUsers: User[];
  unfilteredUserCount: number;
  teamDictionary: Record<string, Organisation>;
}

const UsersTableView: React.FC<UsersTableViewProps> = ({
  filteredUsers,
  unfilteredUserCount,
  teamDictionary,
}) => {
  return (
    <UsersTable
      filteredUsers={filteredUsers}
      unfilteredUserCount={unfilteredUserCount}
      teamDictionary={teamDictionary}
    />
  );
};

export default UsersTableView;
